export default "__VITE_PUBLIC_ASSET__e59903f6__"